import React from 'react';
import { ErrorPop } from "@platform/base";
import './index.less';

function isError(data) {
    let { saga_status = {} } = data.values || data;
    return saga_status.value === "1";
}
export default function useErrorTips(Table) {
    return class ErrorTipsTable extends React.Component {
        /** 根据后台返回的数据saga_status === 1 来判断是否需要禁用列，此处需要判断该变量设置表格数据中那一列的禁用属性 */
        render() {
            //根据checkbox属性和index属性确定错误提示图标是否显示
            let { checkboxConfig, indexConfig, columns, rowProps } = this.props;
            if(columns && columns.length && (checkboxConfig?.enable || indexConfig?.enable)){
                columns = [...columns];
                let oldRender = columns[0].render;
                columns[0] = {
                    ...columns[0],
                    render: (row, viewIndex) => isError(row) ? <ErrorPop record={row.values || row} /> : oldRender?.(row, viewIndex),
                };
            }
            return (
                <Table 
                    {...this.props} 
                    columns={columns}
                    rowProps={(row, viewIndex) => {
                        let rawRowProps = rowProps?.(row, viewIndex) || {};
                        return {
                            ...rawRowProps,
                            onClick: e => {
                                if(isError(row)){
                                    return;
                                }
                                rawRowProps?.onClick?.(e);
                            },
                        };
                    }}
                    // TODO:
                    total={this.handleTotal}
                />
            );
        }

        handleTotal = row => {
            const { total } = this.props;
            if(isError(row)){
                return;
            }
            total?.(row);
        }
    };
    
}

useErrorTips.displayName = 'useErrorTips';
useErrorTips.dependence = [];
useErrorTips.hooks = function(){
    return {
        setErrorKeys: keys => {
            this.store.errorRowKeys = keys;
        },
        getErrorKeys: () => {
            return this.store.errorRowKeys || new Set();
        },
    };
};
useErrorTips.propsGenerator = function(props) {
    let { store, rows } = props,
        errorKeys = store.getErrorKeys(),
        disabledKeys = store.getDisabledKeys();

    rows.forEach(row => {
        if(isError(row)) {
            if(!errorKeys.has(row.key)) { // 错误行不在errorKeys里
                errorKeys.add(row.key);
                disabledKeys.add(row.key);
                
                store.setErrorKeys(errorKeys);
                store.setDisabledKeys(disabledKeys); // setDisableKeys会forceUpdate
            }
        } else {
            if(errorKeys.has(row.key)) { // 非错误行在errorKeys里（界面重试数据从异常变正常了）
                errorKeys.delete(row.key);
                disabledKeys.delete(row.key);
                
                store.setErrorKeys(errorKeys);
                store.setDisabledKeys(disabledKeys); // setDisableKeys会forceUpdate
            }
        }
    });

    return props;
};